import { applyMiddleware, compose, createStore } from "redux";
import { connectRouter, routerMiddleware } from "connected-react-router";
import logger from "redux-logger";
import rootReducer from "./reducers";
import createSagaMiddleware from "redux-saga";
import rootSaga from "../sagas";

const configureStore = (history, initialState = {}) => {
  // ======================================================
  // Middleware Configuration
  // ======================================================
  const sagaMiddleware = createSagaMiddleware();

  const middleware = [routerMiddleware(history), sagaMiddleware];

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = [];
  let composeEnhancers = compose;

  if (process.env.NODE_ENV === "development") {
    if (window.location.hash === "#debug") {
      const { createLogger } = require(`redux-logger`);
      const logger = createLogger({
        level: "warn",
        duration: true,
        diff: true,
        collapsed: (getState, action, logEntry) => !logEntry.error,
      });
      middleware.push(logger);
    }
    if (typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === "function") {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createStore(
    connectRouter(history)(rootReducer),
    initialState,
    composeEnhancers(applyMiddleware(...middleware), ...enhancers),
  );

  let sagaTask = sagaMiddleware.run(function*() {
    yield rootSaga();
  });

  if (module.hot) {
    module.hot.accept("./reducers", () => {
      const reducer = require("./reducers").default;
      store.replaceReducer(connectRouter(history)(reducer()));
    });

    module.hot.accept("../sagas", () => {
      const getNewSagas = require("../sagas").default;
      sagaTask.cancel();
      sagaTask.done.then(() => {
        sagaTask = sagaMiddleware.run(function* replacedSaga(action) {
          yield getNewSagas();
        });
      });
    });
  }

  return store;
};

export default configureStore;
